// File: src/components/AmountSelector.jsx
import React, { useState, useEffect } from "react";

/**
 * AmountSelector
 * Props:
 *  - initialCredits (number)
 *  - onChange({ credits, amount })
 *  - conversionRate (credits -> cents) default 100 credits = $1 => 100 cents per credit? We'll use simple conversion: 100 credits = $1 (i.e., 1 credit = $0.01)
 */
export default function AmountSelector({
  initialCredits = 500,
  onChange,
  conversionRate = 0.18,
}) {
  // conversionRate: dollars per credit (default 0.01 => 100 credits = $1)
  const presets = [500, 1000, 2000];
  const [credits, setCredits] = useState(initialCredits);

  useEffect(() => {
    const dollars = Number((credits * conversionRate).toFixed(2));
    const cents = Math.round(dollars * 100);
    onChange &&
      onChange({
        credits,
        amountCents: cents,
        amountDisplay: `$${dollars.toFixed(2)}`,
      });
  }, [credits, conversionRate, onChange]);
  const handleAmountChange = (e) => {
    let value = e.target.value;

    // Remove decimals if typed
    value = value.replace(/\D+/g, ""); // removes anything not digits

    setCredits(value);
  };
  return (
    <div>
      <div className="mb-3 text-sm font-medium text-gray-700">
        Choose Credits
      </div>

      <div className="flex gap-2 mb-3">
        {presets.map((p) => (
          <button
            key={p}
            onClick={() => setCredits(p)}
            className={`px-3 py-2 rounded-md border ${
              credits === p
                ? "bg-indigo-600 text-white border-indigo-600"
                : "bg-white text-gray-700 border-gray-200"
            }`}
          >
            {p} credits
          </button>
        ))}
      </div>

      <div className="mb-3">
        <label className="block text-xs font-medium text-gray-600 mb-1">
          Custom credits
        </label>
        <input
          type="number"
          value={credits}
          min={500}
          onChange={handleAmountChange}
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-300"
        />
      </div>

      <div className="text-sm text-gray-600">
        <span className="font-semibold">{credits}</span> credits =&nbsp;
        <span className="font-medium">{`$${(credits * conversionRate).toFixed(
          2
        )}`}</span>
      </div>
    </div>
  );
}
